<template>
  <div>
    <div class="mdl-card_disclaimer">
      <div class="mdl-card-disclaimer-left">
        <div class="div_disclaimer">
          * Os valores apresentados são apenas estimativas e não garantem nenhum direito
          antecipado. Saiba mais...
        </div>
      </div>
      <div class="mdl-card-disclaimer-right" @click="openModal" style="cursor: pointer">
        <ArrowRightCircleOutline :size="40" style="color: #003366;" />
      </div>
    </div>
    <!-- Disclaimer Modal -->
    <Modal v-if="isModalVisible" style="padding: 0px;">
      <template v-slot:body>
        <div class="container-filho display-modal">
          <div class="div-header">
            <Titulo :title="titulo" style="margin-top: 15px" />
            <span class="close" @click="closeModal">&times;</span>
          </div>
          <div class="body-modal" v-html="mensagem"></div>
          <button class="mf__btn--confirmar" @click="closeModal" style="margin: 15px 0px;" >Ok, entendi!</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
"use strict";

import Modal from "./Modal.vue";
import Titulo from "./Titulo.vue";
import { mapGetters } from "vuex";
import ArrowRightCircleOutline from "vue-material-design-icons/ArrowRightCircleOutline.vue";

export default {
  props: {
    tipo: "",
  },
  components: {
    Modal,
    Titulo,
    ArrowRightCircleOutline
  },
  computed: {
    ...mapGetters({
      settingsDadosEntidade: "settingsDadosEntidade",
    }),
  },
  data() {
    return {
      titulo: "",
      mensagem: "",
      isModalVisible: false, // Controla a visibilidade do modal
    };
  },
  created() {
    if (this.settingsDadosEntidade) {
      this.titulo = `Transparência<br>${this.settingsDadosEntidade.nome}`;
      this.mensagem = this.settingsDadosEntidade.disclaimer[this.tipo];
    }
  },
  methods: {
    closeModal() {
      this.isModalVisible = false; // Fecha o modal
    },
    openModal() {
      console.log("Abrindo disclaimer");
      this.isModalVisible = true; // Abre o modal
    },
  },
};
</script>

<style scoped>
.display-modal {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.div-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mdl-card-disclaimer-left {
  float: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 89%;
}

.mdl-card-disclaimer-right {
  float: right;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.icon-button-disclaimer {
  color: #003366;
  border-radius: 20px;
  border: 1px darkblue solid;
}

.div_disclaimer {
  font-family: "MaisFuturo-Medium";
  line-height: 10px;
  font-size: 10px;
  font-weight: 200;
  padding-bottom: 0px !important;
}

.mdl-card_disclaimer {
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
}

p {
  font-family: "MaisFuturo-Regular", sans-serif !important;
  font-size: 12px !important;
  margin: 0 0 8px !important;
  line-height: 16px !important;
}
.margin-text {
  margin-top: 15px;
  margin-bottom: 20px;
}

.body-modal {
  text-align: justify;
  font-size: 12px;
  overflow: auto;
}
</style>
